import React from "react";
import axios from "axios";
/* eslint-disable @typescript-eslint/no-var-requires */
const qs = require("qs");
// all api use https
class Api extends React.Component{
    static jobsAllLists(team: string | null ){
        return axios.post(
            "https://api.oddrun.ir/v1/job/listAll",
            qs.stringify({
              team:team
            }),
            {
              headers: {
                "ODDRUN_IDENTIFIER": JSON.parse(
                  localStorage.getItem("oddruN@2021%") || '{}'
                ).identifier,
                "ODDRUN_TOKEN":JSON.parse(
                    localStorage.getItem("oddruN@2021%") || '{}'
                  ).token,
                "Content-Type": "application/x-www-form-urlencoded",
                Accept: "application/json"
              }
            }
          )
      }
      

      static AllRequests(id:number){
        return axios.post(
            "https://api.oddrun.ir/v1/application/listAll",
            qs.stringify({
              id:id
            }),
            {
              headers: {
                "ODDRUN_IDENTIFIER": JSON.parse(
                  localStorage.getItem("oddruN@2021%") || '{}'
                ).identifier,
                "ODDRUN_TOKEN":JSON.parse(
                    localStorage.getItem("oddruN@2021%") || '{}'
                  ).token,
                "Content-Type": "application/x-www-form-urlencoded",
                Accept: "application/json"
              }
            }
          )
      }

      static jobsAdd(persianTitle: string,englishTitle: string,team: null | string,desc: string){
        return axios.post(
            "https://api.oddrun.ir/v1/job/add",
            qs.stringify({
              persianTitle:persianTitle,
              englishTitle:englishTitle,
              team:team,
              desc:desc
            }),
            {
              headers: {
                "ODDRUN_IDENTIFIER": JSON.parse(
                  localStorage.getItem("oddruN@2021%") || '{}'
                ).identifier,
                "ODDRUN_TOKEN":JSON.parse(
                    localStorage.getItem("oddruN@2021%") || '{}'
                  ).token,
                "Content-Type": "application/x-www-form-urlencoded",
                Accept: "application/json"
              }
            }
          )
      }
      static editJob(en: string | Array<string>,fa: string | Array<string>,team: null | string,desc: string,id: number){
        return axios.post(
            "https://api.oddrun.ir/v1/job/edit",
            qs.stringify({
              englishTitle: typeof en === 'string' ? en : en[0],
              persianTitle: typeof fa === 'string' ? fa : fa[0],
              desc:desc,  
              team:team,
              id:id,
            }),
            {
              headers: {
                "ODDRUN_IDENTIFIER": JSON.parse(
                  localStorage.getItem("oddruN@2021%") || '{}'
                ).identifier,
                "ODDRUN_TOKEN":JSON.parse(
                    localStorage.getItem("oddruN@2021%") || '{}'
                  ).token,
                "Content-Type": "application/x-www-form-urlencoded",
                Accept: "application/json"
              }
            }
          )
      }
      
      static addOrEditFromPromp(obj: {titleFa: string, titleEn: string, id: number, desc: string, team: string | null}){
       const keys =  Object.keys(obj)
       if(keys.includes('id')){
        return axios.post(
          "https://api.oddrun.ir/v1/job/edit",
          qs.stringify({
            persianTitle:obj.titleFa,
            englishTitle:obj.titleEn,
            id:obj.id,
            team:obj.team,
            desc:obj.desc
          }),
          {
            headers: {
              "ODDRUN_IDENTIFIER": JSON.parse(
                localStorage.getItem("oddruN@2021%") || '{}'
              ).identifier,
              "ODDRUN_TOKEN":JSON.parse(
                  localStorage.getItem("oddruN@2021%") || '{}'
                ).token,
              "Content-Type": "application/x-www-form-urlencoded",
              Accept: "application/json"
            }
          }
        )
       }else{
        return axios.post(
          "https://api.oddrun.ir/v1/job/add",
          qs.stringify({
            persianTitle:obj.titleFa,
            englishTitle:obj.titleEn,
            team:obj.team,
            desc:obj.desc
          }),
          {
            headers: {
              "ODDRUN_IDENTIFIER": JSON.parse(
                localStorage.getItem("oddruN@2021%") || '{}'
              ).identifier,
              "ODDRUN_TOKEN":JSON.parse(
                  localStorage.getItem("oddruN@2021%") || '{}'
                ).token,
              "Content-Type": "application/x-www-form-urlencoded",
              Accept: "application/json"
            }
          }
        )
       }
    
      }
    
      static removeJob(id: number){
        return axios.post(
            "https://api.oddrun.ir/v1/job/remove",
            qs.stringify({
              id:id
            }),
            {
              headers: {
                "ODDRUN_IDENTIFIER": JSON.parse(
                  localStorage.getItem("oddruN@2021%") || '{}'
                ).identifier,
                "ODDRUN_TOKEN":JSON.parse(
                    localStorage.getItem("oddruN@2021%") || '{}'
                  ).token,
                "Content-Type": "application/x-www-form-urlencoded",
                Accept: "application/json"
              }
            }
          )
      }

      static setStatusJob(id: number,status: boolean){
        return axios.post(
            "https://api.oddrun.ir/v1/job/setStatus",
            qs.stringify({
              id:id,
              status:status
            }),
            {
              headers: {
                "ODDRUN_IDENTIFIER": JSON.parse(
                  localStorage.getItem("oddruN@2021%") || '{}'
                ).identifier,
                "ODDRUN_TOKEN":JSON.parse(
                    localStorage.getItem("oddruN@2021%") || '{}'
                  ).token,
                "Content-Type": "application/x-www-form-urlencoded",
                Accept: "application/json"
              }
            }
          )
      }

      static allRequestsforJob(id: number){
        return axios.post(
            "https://api.oddrun.ir/v1/application/listAll",
            qs.stringify({
              id:id,
            }),
            {
              headers: {
                "ODDRUN_IDENTIFIER": JSON.parse(
                  localStorage.getItem("oddruN@2021%") || '{}'
                ).identifier,
                "ODDRUN_TOKEN":JSON.parse(
                    localStorage.getItem("oddruN@2021%") || '{}'
                  ).token,
                "Content-Type": "application/x-www-form-urlencoded",
                Accept: "application/json"
              }
            }
          )
      }
      static loadPdf(id: number){
        return axios.post(
            "https://api.oddrun.ir/v1/application/loadPdf",
            qs.stringify({
              id:id,
            }),
            {
              headers: {
                "ODDRUN_IDENTIFIER": JSON.parse(
                  localStorage.getItem("oddruN@2021%") || '{}'
                ).identifier,
                "ODDRUN_TOKEN":JSON.parse(
                    localStorage.getItem("oddruN@2021%") || '{}'
                  ).token,
                "Content-Type": "application/x-www-form-urlencoded",
                Accept: "application/json"
              }
            }
          )
      }

      static getJob(id: number){
        return axios.post(
            "https://api.oddrun.ir/v1/job/get",
            qs.stringify({
              id:id,
            }),
            {
              headers: {
                "ODDRUN_IDENTIFIER": JSON.parse(
                  localStorage.getItem("oddruN@2021%") || '{}'
                ).identifier,
                "ODDRUN_TOKEN":JSON.parse(
                    localStorage.getItem("oddruN@2021%") || '{}'
                  ).token,
                "Content-Type": "application/x-www-form-urlencoded",
                Accept: "application/json"
              }
            }
          )
      }
}

export default Api;